import React from "react";
const CampaignBanner = (props) => {
	const { ctaLink, theme, title } = props.data;

	return (
		<div className="campaign-banner-grid">
			<div className="campaign-banner-text">
				<span className="campaign-banner-text-title">{title}</span>
				<div className="campaign-banner-text-label">
					<span>
						<a
							className="campaign-banner-text-link"
							href={ctaLink.url}
							target={ctaLink.target}
							data-a="true"
							data-a-cat="User Engagement"
							data-a-act="Campaign Banner"
							data-a-lbl={ctaLink.title}
							aria-label={ctaLink.title}
						>
							{ctaLink.title}
						</a>
					</span>
				</div>
			</div>
			{theme === "SMA" ? (
				<div className="campaign-banner-image sma"></div>
			) : (
				<div className="campaign-banner-image fi"></div>
			)}
		</div>
	);
};

export default CampaignBanner;
